// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"827c753e","232":"f8c9659b","237":"c1289749","357":"b3a991d2","526":"66e98fef","787":"1f0ca4ea","872":"0e620d66"}[chunkId] + ".chunk.js";
};